<template>
  <qx-card-form title="员工信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {mapState} from 'vuex';
export default {
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        employeeAttributesOptions: [],
        form: [
          {
            label: '员工姓名',
            value: 'linkman',
            type: 'input',
          },
          {
            label: '身份证号',
            value: 'identification',
            type: 'input',
          },
          {
            label: '员工工号',
            value: 'employeeNumber',
            type: 'input',
          },
          {
            label: '员工职位',
            value: 'staffPosition',
            type: 'input',
          },
          {
            label: '员工部门',
            value: 'orgIds',
            type: 'select',
            filterable: true,
            multiple: true,
            default: [],
          },
          {
            label: '员工入职时间',
            value: 'joinedDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '员工属性',
            value: 'employeeAttributes',
            type: 'select',
            default: [],
            attr: {
              clearable: true,
            },
          },
        ],
        rules: {
          linkman: [ // 员工姓名
            { required: true, message: '请输入员工姓名', trigger: 'blur' },
          ],
          identification: [ // 身份证号
            { required: false, message: '请输入身份证号', trigger: 'blur' },
          ],
          orgIds: [ // 员工部门
            { required: true, message: '请选择员工部门', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async getList () {
      this.baseForm.orgIdsOptions = await getDepartmentAllList({
        pid: -2,
      });
      const enumsList = await getEnumList({
        codeType: 'EMPLOYEE_ATTRIBUTES',
      });
      this.baseForm.employeeAttributesOptions = enumsList[0];
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.orgIds = formData.orgIds.join(',');
        formData.joinedDate = formData.joinedDate ? this.formatDate(formData.joinedDate) : '';
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      res.orgIds = res.orgIds.join(',');
      return res;
    },
    async init (data = {}) {
      if (data.orgIds) {
        data.orgIds = data.orgIds.split(',');
        data.orgIds = data.orgIds.map((id) => Number(id));
      } else {
        data.orgIds = [];
      }
      if (data.employeeAttributes && data.employeeAttributes !== -1) {
        data.employeeAttributes = String(data.employeeAttributes);
      } else {
        data.employeeAttributes = [];
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
